// src/vocabulary/B1/unit4/questions.js

const questions = [
  // 🟢 Easy – meaning
  {
    id: 1,
    type: "choice",
    question: "What does 'kind' mean?",
    options: ["كسول", "طيب", "غاضب"],
    correctAnswer: "طيب"
  },

  {
    id: 2,
    type: "choice",
    question: "Which word means 'مهذب'?",
    options: ["lazy", "polite", "honest"],
    correctAnswer: "polite"
  },

  // 🟡 Medium – usage
  {
    id: 3,
    type: "choice",
    question: "Choose the correct sentence:",
    options: [
      "He is very friendly.",
      "He very friendly is.",
      "He friendly very."
    ],
    correctAnswer: "He is very friendly."
  },

  {
    id: 4,
    type: "choice",
    question: "Which sentence describes character, not appearance?",
    options: [
      "She is tall.",
      "He is honest.",
      "They have short hair."
    ],
    correctAnswer: "He is honest."
  },

  // 🔵 Harder – context & logic
  {
    id: 5,
    type: "choice",
    question: "Which person is likely to work a lot?",
    options: [
      "A lazy person",
      "A hard-working person",
      "A shy person"
    ],
    correctAnswer: "A hard-working person"
  },

  {
    id: 6,
    type: "choice",
    question: "Why do people trust someone who is honest?",
    options: [
      "Because he talks a lot",
      "Because he tells the truth",
      "Because he is tall"
    ],
    correctAnswer: "Because he tells the truth"
  }
];

export default questions;


